//////////////////
//////////////////
//////////////////
// Side menu
//////////////////
//////////////////
//////////////////
'use strict';
import debounce from 'raf-throttle';

// export default function($){
    console.log('this comes from side-menu.js example');

    // get items
    var $items = $("[heading-menu-item]");

    // build menu
    var $html = '<li class="sidebar-menu__item[item_class]" [item_targets]><a internal-page-link href="[item_link]" data-item-index="[item_index]">[item_name]</a></li>';
    var $output = "";

    for (var i = 0, leng = $items.length; i < leng; i++) {

        // add id's to items
        //$($items[i]).attr('id', 'heading-item-' + (i+1));
		//adding ids via MenuItemIDHandler.cs - so browser can resolve #links without delay

        var $out = "";

        if (typeof $($items[i]).attr("brochures-publications") !== "undefined") {
        	if($($items[i]).text().length < 1) {
        		$($items[i]).parent().remove()
        	}
        	else {
        		$out = $html.replace("[item_class]", " hide").replace("[item_targets]", "brochures-publications").replace("[item_index]", i).replace("[item_name]", $($items[i]).text()).replace("[item_link]", "#heading-item-"+(i+1));
        	}
        } else {
            $out = $html.replace("[item_class]", "").replace("[item_targets]", "").replace("[item_index]", i).replace("[item_name]", $($items[i]).text()).replace("[item_link]", "#heading-item-"+(i+1));
        }
        $output += $out;
    }

    // Add to page
    $('.sidebar .sidebar-menu .sidebar-menu__level-1').append($output);

    ///////////////////////////////////////
    ///////////////////////////////////////
    // adding scroll spy
    $('body').scrollspy({
        target: ".sidebar-menu",
        offset: 150
    });


    // Nice scrolling on click
    $('.sidebar-menu:not(.sidebar-menu--static)')
        .on('click', '.sidebar-menu__item > a', function(e){
            e.preventDefault();
            var $item = $(this).attr('href');

            document.getElementById($item.substr(1)).scrollIntoView(true);
            window.location.hash = $item.substr(1);
        });

    // Mobile functionality show/hide
    $('.sidebar').on('click', '.sidebar__title', function(){
		// if ($(window).outerWidth() <= 991) {
            if (!!currSmall) {
        	$('.sidebar').toggleClass('show-side-menu');
		}
    });

    // Sticky sidebar
	// if (($('.sidebar__wrapper').length > 0) && !!currBig) {

        var $element = $('.sidebar__wrapper');

        if ($('.sidebar__wrapper--apply-buttons').length > 0) {
            $element = $('.sidebar__wrapper--apply-buttons');
        };

        var $top = $($element).offset().top - $('#block-mainnavigation').outerHeight();

        const setElementWidth = () =>{
			// Set width so it doesnt change when it goes sticky
			$($element).css({
				width: $($element).css('width','').outerWidth() + "px"
			});
        };

        setElementWidth();

		var sideSticky = debounce((function () {

            var $bannerHeight = 0;

            if ($(".banner .banner__image").length > 0) {
                $bannerHeight = $(".banner .banner__image").outerHeight();
            } 
            else if ($(".c-location-map__desktop").length > 0) {
                $bannerHeight = $(".c-location-map__desktop").outerHeight();
            }

            var windowScroll = $(window).scrollTop(),
				$height = $($element).offset().top + $($element).outerHeight(),
				$footerTop = $($element).closest(".sidebar__wrapper--parent").outerHeight() + $bannerHeight + $("nav").outerHeight();

            var $siblingHeight = $('.sidebar__wrapper').closest('.sidebar__wrapper--parent').siblings('.col-md-8').outerHeight();

            $('.sidebar__wrapper').closest('.sidebar__wrapper--parent').css({
                'height': $siblingHeight + 'px'
            });

			if (windowScroll >= $top) {
                $($element).addClass('sticky-sidebar');

                if (($height > $footerTop) && (!$($element).hasClass('fixed-bottom'))) {
                    $($element).addClass('fixed-bottom');
                } else if ((windowScroll + $('#block-mainnavigation').outerHeight() <= $($element).offset().top) && ($($element).hasClass('fixed-bottom'))) {
                    $($element).removeClass('fixed-bottom');
                }

			} else if (windowScroll < $top) {
				$('.sidebar__wrapper').removeClass('sticky-sidebar');
			};
		}), 5, true);

		window.addEventListener('resize', debounce(function(){
            setElementWidth();
            if (!!currSmall) {
                $($element).removeClass('fixed-bottom');
            }
		}, 20, true));

		// Check if loaded document needs a sticky nav, if scrolled or loading to a point low on page
		//$(window).on('load', function () {
		$(document).ready(function(){
            
            if ($(".sticky-sidebar--default").length > 0) {
                $(".sticky-sidebar--default").removeClass("sticky-sidebar--default");
            };

            sideSticky();


            // Check for a scroll event and run the sticky nav
            window.addEventListener('scroll', sideSticky);
		});
		
	// };

// }



// WEBPACK FOOTER //
// ./src/_js/partials/side-menu.js